// extracted by mini-css-extract-plugin
export default {"container":"_4Bkfg0aB7dpBS3NAdpIg","solutionBlock":"TCR_gs4hT4RpVfCHEvmA","solutionSelect":"Rwk2uGZA_ew96_XgOuDW"};